import { createContext } from "react";

export const AppConfigContext = createContext<any>(null);
